<template>
  <div class="user-tab-box">
    <div class="tab-list">
      <div
        :class="['tab-item', isMenuActive(item) ? 'active' : '']"
        v-for="item in showMenuList"
        :key="item.name"
        @click="handleClickTabItem($event, item)"
      >
        <div class="item-icon-box">
          <img v-if="isMenuActive(item)" class="icon" :src="item.activeIcon" alt="">
          <img v-else class="icon" :src="item.icon" alt="">
        </div>
        <div :class="['item-text', isShowNewLabel(item) ? 'new-label' : '']">{{item.label}}</div>
      </div>
    </div>
    <div class="tab-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import { mapActions, mapState } from 'vuex';
import User from '../../../libs/user';

export default {
  data() {
    return {
      showAuditTab: false,
      menuList: [
        // 金棕榈如果要改，要改一下 header.vue 中 goAccount
        {
          name: 'equity',
          label: '权益中心',
          needAdmin: false,
          needShow: true,
          icon: 'https://o.666visa.cn/static/ssqpeer/user/icon-equity.png',
          activeIcon: 'https://o.666visa.cn/static/ssqpeer/user/icon-equity-active.png',
        },
        {
          name: 'balance',
          label: '消费账单',
          needAdmin: false,
          needShow: !User.is_palmyou,
          icon: 'https://o.666visa.cn/static/ssqpeer/user/icon-balance.png',
          activeIcon: 'https://o.666visa.cn/static/ssqpeer/user/icon-balance-active.png',
        },
        {
          name: 'audit',
          label: '对公汇款记录',
          needAdmin: false,
          needShow: !User.is_palmyou,
          icon: 'https://o.666visa.cn/static/ssqpeer/user/icon-audit.png',
          activeIcon: 'https://o.666visa.cn/static/ssqpeer/user/icon-audit-active.png',
        },
        {
          name: 'coupon',
          label: '我的优惠券',
          needAdmin: false,
          needShow: !User.is_palmyou,
          icon: 'https://o.666visa.cn/static/ssqpeer/user/icon-coupon.png',
          activeIcon: 'https://o.666visa.cn/static/ssqpeer/user/icon-coupon-active.png',
        },
        {
          name: 'staff',
          label: '成员管理',
          needAdmin: true,
          needShow: true,
          icon: 'https://o.666visa.cn/static/ssqpeer/user/icon-member.png',
          activeIcon: 'https://o.666visa.cn/static/ssqpeer/user/icon-member-active.png',
        },
        {
          name: 'history_applicant',
          label: '历史申请人',
          needAdmin: false,
          needShow: true,
          icon: 'https://o.666visa.cn/static/ssqpeer/user/icon-history.png',
          activeIcon: 'https://o.666visa.cn/static/ssqpeer/user/icon-history-active.png',
        },
        {
          name: 'address',
          label: '地址管理',
          needAdmin: false,
          needShow: true,
          icon: 'https://o.666visa.cn/static/ssqpeer/user/icon-address.png',
          activeIcon: 'https://o.666visa.cn/static/ssqpeer/user/icon-address-active.png',
        },
        {
          name: 'shop',
          label: '飞猪店铺对接',
          needAdmin: true,
          needShow: true,
          icon: 'https://o.666visa.cn/static/ssqpeer/user/icon-shop.png',
          activeIcon: 'https://o.666visa.cn/static/ssqpeer/user/icon-shop-active.png',
        },
        {
          name: 'profile',
          label: '账号设置',
          needAdmin: false,
          needShow: true,
          icon: 'https://o.666visa.cn/static/ssqpeer/user/icon-account.png',
          activeIcon: 'https://o.666visa.cn/static/ssqpeer/user/icon-account-active.png',
        },
      ],
    };
  },
  computed: {
    ...mapState('user', ['userInfo', 'peerData']),
    showMenuList() {
      this.menuList.forEach((el) => {
        if (el.name === 'audit') {
          el.needShow = !User.is_palmyou && this.showAuditTab;
        }
        if (el.name === 'equity') {
          el.needShow = this.peerData && this.peerData.is_display_benefits_center;
        }
        if (el.name === 'history_applicant') {
          el.needShow = this.peerData && this.peerData.archives_count;
        }
      });
      return this.menuList.filter(item => item.needShow && (!item.needAdmin || this.userInfo.is_admin));
    },
  },
  created() {
    if (User.isLogin()) {
      this.isShowAuditTab();
    }
  },
  methods: {
    ...mapActions('user', ['publicAuditQuery']),
    isMenuActive(menuItem) {
      const routerName = this.$route.name;
      let isActive = false;
      if (menuItem.name === routerName) {
        isActive = true;
      }
      if (menuItem.children) {
        menuItem.children.forEach((childrenItem) => {
          if (childrenItem.name === routerName) {
            isActive = true;
          }
        });
      }
      return isActive;
    },
    handleClickTabItem(e, tabItem) {
      sensorsdata.quick('trackHeatMap', e.target);
      if (tabItem.name === 'balance') {
        // 判断点击的是否为消费账单，如果是则需要去除new标签
        const storageData = localStorage.getItem('balancePage') ? JSON.parse(localStorage.getItem('balancePage')) : {};
        storageData.clickedMenu = storageData.clickedMenu || [];
        storageData.clickedMenu.push(User.peer_account_id);
        localStorage.setItem('balancePage', JSON.stringify(storageData));
      }
      this.$router.push({ path: `/user/${tabItem.name}`, query: this.$route.query });
    },
    isShowAuditTab() {
      this.publicAuditQuery().then((res) => {
        if (res.total_count > 0) {
          this.showAuditTab = true;
        } else {
          this.showAuditTab = false;
        }
      });
    },
    isShowNewLabel(config) {
      // 消费账单 & 老用户 & 该功能上线不超过一个月 & 用户没点击过
      const isBalance = config.name === 'balance';
      const isOldUserAndNotExpired = User.peer.is_new_peer === 0; // 老用户，并且后端还会返回null也不需要展示
      const storageData = localStorage.getItem('balancePage') ? JSON.parse(localStorage.getItem('balancePage')) : {};
      const isClicked = storageData.clickedMenu ? storageData.clickedMenu.includes(User.peer_account_id) : false;
      return isBalance && isOldUserAndNotExpired && !isClicked;
    },

  },
};
</script>

<style lang="less" scoped>
.user-tab-box{
  margin-top: 20px;
  background: #FFFFFF;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.06);
  width: 100%;
  display: flex;
  min-height: 600px;
  .tab-list{
    flex-shrink: 0;
    width: 200px;
    padding: 20px 0;
    border-right: 1px solid #DEE2E6;
    .tab-item{
      width: 100%;
      height: 48px;
      display: flex;
      align-items: center;
      padding-left: 36px;
      margin-bottom: 12px;
      position: relative;
      cursor: pointer;
      .item-text {
        &.new-label {
          position: relative;
          &::after {
            content: "";
            position: absolute;
            left: 100%;
            top: 50%;
            transform: translateY(-50%);
            background: url(../../../assets/imgs/user/balance-new-label.png) no-repeat center / 100% 100%;
            width: 38px;
            height: 24px;
            z-index: 2;
            margin-left: 1px;
          }
        }
      }
      &:last-child{
        margin-bottom: 0;
      }
      .item-icon-box{
        font-size: 0;
        flex-shrink: 0;
        margin-right: 4px;
        .icon{
          width: 24px;
          height: 24px;
        }
      }
      .item-text{
        color: #2F333D;
        font-size: 16px;
      }
      &.active{
        background: rgba(89, 159, 255, 0.06);
        &::after{
          content: "";
          width: 4px;
          height: 48px;
          background: #599FFF;
          position: absolute;
          left: 0;
          top: 0;
        }
        .item-text{
          color: #599FFF;
          font-weight: 400;
        }
      }
    }
  }
  .tab-content{
    flex-grow: 1;
    // overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/components/user-tab.vue